import { Box, HStack } from "@chakra-ui/react"
import { Graph } from "@hydrologiq/schemas/1.0.0/installationPage"
import IBuilder from "../IBuilder"
import { IGraphsProps } from "../IGraphs"
import TimeSeriesGraphV1 from "../1.0.0/graphs/TimeSeriesGraph"
import TimeSeriesGraphV2 from "./graphs/TimeSeriesGraph"
import { JSX } from "react"
import { toKey } from "@hydrologiq/common/test/toKey"
type GraphsProps = IGraphsProps<Graph>

const Graphs: IBuilder<GraphsProps> = (props: GraphsProps) => {
  const rows = 99
  const layouts = new Array(rows).fill(100)
  const elements: [JSX.Element[]] = [[]]
  const layoutFill = {
    small: 25,
    medium: 50,
    large: 75,
    full: 100,
  }
  const createGraph = (graph: Graph) => {
    const fill = layoutFill[graph.size]
    const row = layouts.findIndex((layout) => layout - fill >= 0)
    if (row == -1) {
      console.error("No more room to fill")
      return
    }
    layouts[row] = layouts[row] - fill

    let element: React.ReactNode = undefined
    const graphId = toKey(`graph-${graph.title}-${elements.length}`)
    switch (graph.type) {
      case "TimeSeries":
        const timeseries = graph.timeseries
        const sourceRange = graph.source.range
        const TimeSeriesGraph = graph.versioning.revision === 1 ? TimeSeriesGraphV1 : TimeSeriesGraphV2
        if (timeseries && sourceRange)
          element = (
            <TimeSeriesGraph
              installationEndDate={props.installationEndDate}
              installationStartDate={props.installationStartDate}
              installationId={props.installationId}
              graph={graph}
              timeseries={timeseries}
              sourceRange={sourceRange}
              assetConfigs={props.assetConfigs}
              assetId={props.assetId}
            />
          )
        break
    }

    const wrapper = (
      <Box
        key={graphId}
        w={{ base: "100%", lg: `${fill}%` }}
        m={5}
        ml={0}
        mt={0}
        pb={{ base: 7.5, lg: 0 }}
        _last={{ mr: 0 }}
        bg="white"
        borderRadius="5px"
        boxShadow="card"
        p={4}
        minHeight="100px"
      >
        {element}
      </Box>
    )
    elements[row] ? elements[row].push(wrapper) : (elements[row] = [wrapper])
  }
  props.graphs.forEach((graph) => createGraph(graph))
  return (
    <Box height={"70vh"} mt={{ base: "20px", md: "10px" }}>
      {elements.map((element, index) => (
        <Box marginTop={"5px"} pb={{ base: 0, lg: index + 1 < elements.length ? 7.5 : 0 }} key={index}>
          <HStack gapY="5px" display={{ base: "block", lg: "flex" }}>
            {element}
          </HStack>
        </Box>
      ))}
    </Box>
  )
}

export default Graphs
